// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".creative-request-fab{position:fixed;bottom:24px;right:24px;width:56px;height:56px;border-radius:50%;background-color:#007bff;color:white;border:none;box-shadow:0 2px 5px rgba(0,0,0,0.2);cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all 0.3s ease;z-index:1000}.creative-request-fab:hover{background-color:#0056b3;transform:scale(1.05)}.creative-request-fab:active{transform:scale(0.95)}.creative-request-fab i{font-size:24px}\n", ""]);
// Exports
module.exports = exports;
